import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const NoDetailsModal = ({ showNoDataModal, setShowNoDataModal }) => {
    return (
        <Modal show={showNoDataModal} centered>
            <Modal.Body className="text-center p-4">
                <p className="mb-0 text-danger fw-bold">
                    No details found please fill manually
                </p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center border-0">
                <Button
                    variant="primary"
                    size="sm"
                    className="px-4"
                    onClick={() => setShowNoDataModal(false)}
                >
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default NoDetailsModal